<template>
  <section>
    <p class="title is-1">Reporte de apartados</p>
    <b-breadcrumb align="is-left">
      <b-breadcrumb-item tag='router-link' to="/">Inicio</b-breadcrumb-item>
      <b-breadcrumb-item active>Apartados</b-breadcrumb-item>
    </b-breadcrumb>

    <busqueda-en-fecha @seleccionada="onBusquedaEnFecha" />
    <div class="field mt-4">
      <div class="field has-addons">
        <div class="control is-expanded">
          <busqueda-cliente @seleccionado="onSeleccionado" @deseleccionado="onDeseleccionado" />
        </div>
      </div>
    </div>
    <mensaje-inicial class="mt-2" :titulo="'No se han encontrado apartados :('"
      :subtitulo="'Aquí aparecerán los apartados registrados'" v-if="apartados.length < 1" />
    <div class="mt-2" v-if="apartados.length > 0">
      <cartas-totales-filtradas :registros="totalesGenerales" />
      <cartas-totales-filtradas :registros="apartadosFiltrados" />
      <tabla-cuentas-apartados :datos="apartados" @imprimir="onGenerarComprobante" :printHref="printHref"
        @actualizar-cuentas="obtenerApartados" @cargarRegistrosFiltrados="guardarCuentasApartadosFiltrados"
        :tasa="tasa" />
    </div>
    <comprobante-compra :venta="this.apartadoSeleccionado" :tipo="'apartado'" @impreso="onImpreso"
      v-if="mostrarComprobante" :porPagar="porPagar" :tamaño="tamaño"
      :tasa="tasa" />
    <b-loading :is-full-page="true" v-model="cargando" :can-cancel="false"></b-loading>
  </section>
</template>

<script>
import BusquedaCliente from '../Clientes/BusquedaCliente'
import BusquedaEnFecha from '../Extras/BusquedaEnFecha'
import MensajeInicial from '../Extras/MensajeInicial'
import CartasTotalesFiltradas from '../Extras/CartasTotalesFiltradas'
import TablaCuentasApartados from './TablaCuentasApartados'
import ComprobanteCompra from './ComprobanteCompra'
import HttpService from '../../Servicios/HttpService'
import Utiles from '../../Servicios/Utiles'

export default {
  name: "ReporteApartados",
  components: { BusquedaEnFecha, TablaCuentasApartados, MensajeInicial, CartasTotalesFiltradas, ComprobanteCompra, BusquedaCliente },

  data: () => ({
    tasa: null,
    filtros: {
      fechaInicio: "",
      fechaFin: ""
    },
    tamaño: 'tiquera',
    porPagar: 0,
    cargando: false,
    apartados: [],
    totalesGenerales: [],
    apartadoSeleccionado: null,
    mostrarComprobante: false,
    clienteId: null,
    apartadosFiltrados: [],
  }),

  mounted ()
  {
    this.obtenerApartados()
  },

  computed: {
    printHref ()
    {
      let href = '#/pdf/apartados'

      const entries = Object.entries(this.filtros)
        .filter(entry => Boolean(entry[1]))

      if (this.clienteId) {
        entries.push(['clienteId', this.clienteId])
      }

      if (entries.length === 0) return href

      const filtros = Object.fromEntries(entries)
      const params = new URLSearchParams(filtros).toString()
      return `${href}?${params}`
    },
  },

  methods: {
    formatoMonto (valor)
    {
      return Utiles.formatoMonto(valor)
    },

    onImpreso (resultado)
    {
      this.mostrarComprobante = resultado
    },

    async onGenerarComprobante (apartado)
    {
      this.apartadoSeleccionado = apartado

      const porPagar = await HttpService.obtenerConConsultas('ventas.php', {
        accion: 'por_pagar', id: apartado.id,
      })

      this.porPagar = porPagar
      this.$buefy.dialog.confirm({
        message: 'Selecciona el tamaño a imprimir',
        cancelText: 'Carta',
        confirmText: 'Tiquera',
        trapFocus: true,
        onConfirm: () =>
        {
          this.tamaño = 'tiquera'
          this.mostrarComprobante = true
        },
        onCancel: () =>
        {
          this.tamaño = 'carta'
          this.mostrarComprobante = true
        },
      })
    },

    onBusquedaEnFecha (fechas)
    {
      this.filtros.fechaInicio = fechas[0].toISOString().split('T')[0]
      this.filtros.fechaFin = fechas[1].toISOString().split('T')[0]
      this.obtenerApartados()
    },

    async obtenerApartados ()
    {
      this.cargando = true
      let payload = {
        filtros: {
          ...this.filtros,
          clienteId: this.clienteId || null
        },
        accion: 'obtener_apartados'
      }
      HttpService.obtenerConConsultas('ventas.php', payload)
        .then(resultado =>
        {
          this.apartados = resultado.apartados
          this.tasa = resultado.tasa.valor ?? 0;
          this.apartadosFiltrados = resultado.apartadosFiltrados.map(apartado =>
          {
            return {
              nombre: apartado.metodo_pago,
              total: `${this.formatoMonto(apartado.total)}`,
              totalBs: `${this.formatoMonto(apartado.totalBs)}`,
              icono: 'credit-card-outline',
              clase: 'has-text-info',
              cantidad: apartado.cuentas_apartados_totales,
            }
          })

          this.guardarCuentasApartadosFiltrados()

          this.totalesGenerales = [
            { nombre: "# Apartados", total: this.apartados.length, icono: "wallet-travel", clase: "has-text-primary" },
            { nombre: "Total ", total: '$' + this.formatoMonto(resultado.totalApartados), icono: "cash-fast", clase: "has-text-success" },
            { nombre: "Por pagar Dólares", total: '$' + this.formatoMonto(resultado.totalPorPagar), icono: "alert", clase: "has-text-danger" },
            { nombre: "Por pagar Bolívares", total: 'Bs. ' + this.formatoMonto(resultado.totalPorPagar * this.tasa), icono: "alert", clase: "has-text-danger" },
            { nombre: "Pagos", total: '$' + this.formatoMonto(resultado.totalPagos), icono: "account-cash", clase: "has-text-grey-light" },
            { nombre: "# Productos", total: Utiles.calcularProductosVendidos(this.apartados), icono: "package-variant", clase: "has-text-warning" },
            { nombre: "Ganancia", total: '$' + this.formatoMonto(Utiles.calcularTotalGanancia(this.apartados)), icono: "currency-usd", clase: "has-text-info" }
          ]
          this.cargando = false
        })
    },

    guardarCuentasApartadosFiltrados ()
    {
      const apartadosFiltrados = this.apartadosFiltrados.map(apartado =>
      {
        return {
          nombre: apartado.nombre,
          total: apartado.total,
          totalBs: apartado.totalBs,
          cantidad: apartado.cantidad,
        }
      })
      localStorage.setItem('metodos_pago', JSON.stringify(apartadosFiltrados));
    },


    onDeseleccionado ()
    {
      this.clienteId = null
      this.obtenerApartados()
    },

    onSeleccionado (cliente)
    {
      this.clienteId = cliente.id

      if (this.debounceTimeout) {
        clearTimeout(this.debounceTimeout);
      }

      this.debounceTimeout = setTimeout(() =>
      {
        this.obtenerApartados();
      }, 500);
    },
  }
}
</script>
